export const ERROR_TEXT =
  'Something went wrong. Try refreshing the page or viewing your report later.'
export const LEADER_TRACK = 'sela leader'
export const LOADING_TEXT = 'Loading report data...'
export const STAFF_TRACK = 'sela staff'
